import io from 'socket.io-client'

const socket = io(process.env.NEXT_PUBLIC_MEDUSA_BACKEND_URL ?? '')

export default socket
